import { useEffect } from 'react';
import { DEVELOPER_ESCALATION } from '@atlassian/jira-servicedesk-work-category/src/common/constants.tsx';
import type { WorkCategoryAllSupported } from '@atlassian/jira-servicedesk-work-category/src/controllers/use-work-category-all-supported/types.tsx';
import { createStore, createHook, createActionsHook } from '@atlassian/react-sweet-state';
import type { RequestType } from '../../services/get-escalations-request-types/types';
import type { State, Actions, HasActionReturn, GetActionReturn, VoidActionReturn } from './types';

const initialState: State = {
	cache: {},
};

export const actions = {
	has:
		(projectKey: string): HasActionReturn =>
		({ getState }) =>
			projectKey in getState().cache,

	get:
		(projectKey: string): GetActionReturn =>
		({ getState }) =>
			getState().cache[projectKey] ?? [],

	set:
		(projectKey: string, value: RequestType[]): VoidActionReturn =>
		({ getState, setState }) =>
			setState({
				cache: {
					...getState().cache,
					[projectKey]: value,
				},
			}),

	flush:
		(): VoidActionReturn =>
		({ setState }) =>
			setState({
				cache: {},
			}),
};

const store = createStore<State, Actions>({
	name: 'CustomerServiceEscalationsCachedResquestType',
	initialState,
	actions,
});

export const useCachedEscalationsRequestType = createHook<State, Actions, RequestType[], string>(
	store,
	{
		selector: ({ cache }, projectKey) => cache[projectKey] ?? [],
	},
);

export const useCachedEscalationsRequestTypeActions = createActionsHook(store);

export const useFlushCachedEscalationsRequestType = (
	workCategory: WorkCategoryAllSupported | undefined,
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	dependency: any,
) => {
	const { flush } = useCachedEscalationsRequestTypeActions();

	useEffect(() => {
		if (workCategory === DEVELOPER_ESCALATION) flush();
	}, [flush, workCategory, dependency]);
};
